module.exports = __webpack_public_path__ + "img/logo.acb56b3b.svg";